'use client';

import { LINK } from '@constants';
import { useEventStore } from 'app/_event';
import { useRouter } from 'next/navigation';
import { DefaultViewingBanner } from './DefaultViewingBanner';
import { XmasViewingBanner } from './XmasViewingBanner';

export const ViewingBannerSlot = () => {
  const router = useRouter();
  const xmasMeta = useEventStore((s) => (s.activeEvent === 'xmas' ? s.meta : null));

  const handleClick = () => router.push(LINK.STAMP);

  return xmasMeta !== null ? (
    <XmasViewingBanner mainColor={xmasMeta.colors.main} onClick={handleClick} />
  ) : (
    <DefaultViewingBanner onClick={handleClick} />
  );
};
